export enum EApplicationUrls {
  APPLICATION = 'application',
  STEP = 'step',
  VERIFY = 'verify',
  ANIMAL = 'animal',
  DETAILS = 'details',
  TENANT = 'tenant',
  PAYMENT = 'payment',
  ACCESS_CODE = 'access-code',
  PROPERTIES = 'properties',
  PROPERTY = 'property',
  UNITS = 'units',
  SIGN = 'sign',
  PROPERTY_MANAGEMENT = 'property-management',
  RETRACT = 'retract',
  CONFIRM_PRIVACY_POLICY = 'confirm-privacy-policy',
  INCOMPLETE = 'incomplete',
  MOVE_IN_DATE = 'move-in-date',
  UPLOADABLE_VET_RECORDS = 'uploadable-vet-records',
  ANIMAL_FIELD_VISIBILITY = 'animal-field-visibility',
}

export const COMMON_PROPERTY_UNITS_URL = `${
  import.meta.env.REACT_APP_HOSTNAME
}/common/api/v2/property/units`;
